// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-09b6d14a]{transition:all .15s}svg.rotate[data-v-09b6d14a]{transform:rotate(90deg)}", ""]);
// Exports
module.exports = exports;
